import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

export interface ActiveUserJourney {
  name: string
  journeyId: string
  createdAt: number
  variant?: string
  tags: string[]
  frustrations: string[]
  frictions: string[]
}

export interface UserJourneyState {
  active?: ActiveUserJourney
}

export const userJourneyInitialState: UserJourneyState = {
  active: undefined,
}

const userJourneySlice = createSlice({
  name: 'userJourney',
  initialState: userJourneyInitialState,
  reducers: {
    syncActiveJourney(state, action: PayloadAction<ActiveUserJourney | undefined>) {
      state.active = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => userJourneyInitialState)
  },
})

export const { syncActiveJourney } = userJourneySlice.actions

export default userJourneySlice.reducer
